export * from "./myresources-config.view";
